export default [
	{
		value: 'acupuncture',
		label: 'Acupuncture',
		icon: ['fal', 'map-pin'],
		description:
			'Acupuncture is a treatment derived from ancient Chinese medicine. Fine needles are inserted at certain sites in the body.',
	},
	{
		value: 'brain',
		label: 'Brain Machine Interface (BMI)',
		icon: ['fas', 'brain'],
		description:
			'A connection to read signals from your brain to other devices, or to stimulate your brain based on inputs from an external device.',
	},
	{
		value: 'brain_stimulation',
		label: 'Brain Stimulation',
		icon: ['fas', 'brain'],
		description: 'Stimulating brain cells using external equipment.',
	},
	{
		value: 'equipment',
		label: 'Devices',
		icon: ['fas', 'wheelchair'],
		description:
			'Devices can be used to enhance functionality, or in some cases give new functionality.',
	},
	{
		value: 'pharma',
		label: 'Drugs',
		icon: ['fas', 'capsules'],
		description: 'Medicines either injected or orally taken',
	},
	{
		value: 'estimulation',
		label: 'Electrical Stimulation',
		icon: ['fas', 'bolt'],
		description:
			'The use of electrical stimulation to stimulate spinal cord circuits.',
	},
	{
		value: 'epidural',
		label: 'Epidural Stimulation',
		icon: ['fas', 'bolt'],
		description:
			'A small stimulator is implanted to stimulate spinal cord circuits.',
	},
	{
		value: 'exo',
		label: 'Exoskeleton',
		icon: ['fas', 'robot'],
		description:
			'A powered exoskeleton is a wearable mobile machine that is powered by a system of electric motors, pneumatics, levers, hydraulics, or a combination of technologies that enable limb movement.',
	},
	{
		value: 'fes',
		label: 'Functional Electrical Stimulation (FES)',
		icon: ['fas', 'bolt'],
		description:
			'A technique that uses low-energy electrical pulses to artificially generate body movements in individuals who have been paralyzed due to injury to the central nervous system.',
	},
	{
		value: 'intermittent_hypoxia',
		label: 'Intermittent Hypoxia',
		icon: ['fas', 'inhaler'],
		description:
			'(This involves brief episodes of breathing lower oxygen air, mixed with episodes of breathing normal air.',
	},
	{
		value: 'nmes',
		label: 'Neuromuscular Electrical Stimulation (NMES)',
		icon: ['fas', 'bolt'],
		description:
			'Controls the elicitation of muscle contraction using electric impulses.',
	},
	{
		value: 'nutrition',
		label: 'Nutrition',
		icon: ['fas', 'carrot'],
		description:
			'Changes to diet or intake of nutrients including proteins, carbohydrates, fats, vitamins, minerals, and water.',
	},
	{
		value: 'observational',
		label: 'Observational',
		icon: ['fal', 'eye'],
		description:
			'This trial is observational where investigators will monitor you.',
	},
	{
		value: 'rehabilitation',
		label: 'Rehabilitation',
		icon: ['fas', 'dumbbell'],
		description:
			'Rehabilitation is care that can help you get back, keep, or improve abilities that you need for daily life. These abilities may be physical, mental, and/or cognitive (thinking and learning).',
	},
	{
		value: 'safety',
		label: 'Safety',
		icon: ['fas', 'football-helmet'],
		description: 'This trial is to establish the safety of any treatment.',
	},
	{
		value: 'stemcells',
		label: 'Stem Cells',
		icon: ['fal', 'atom-alt'],
		description:
			'Stem cells are cells with the potential to develop into many different types of cells in the body. They serve as a repair system for the body.',
	},
	{
		value: 'surgery',
		label: 'Surgical Procedure',
		icon: ['fas', 'procedures'],
		description:
			'This trial involves a surgical procedure to provide the treatment.',
	},
	{
		value: 'tdcs',
		label: 'Transcranial Direct Current Stimulation (tDCS)',
		icon: ['fas', 'brain'],
		description:
			'Electrical stimulation of areas of your brain using a tDCS device.',
	},
	{
		value: 'tms',
		label: 'Transcranial Magnetic Stimulation (TMS)',
		icon: ['fas', 'brain'],
		description:
			'Magnetic stimulation of areas of your brain using a TMS device.',
	},
	{
		value: 'transcutaneous',
		label: 'Transcutaneous Stimulation',
		icon: ['fas', 'bolt'],
		description:
			'Stimulates the spinal cord circuits using an external stimulator attached via electrodes.',
	},
] as const;
